import {Component, Input, OnInit} from '@angular/core';
import {Device} from "../../model/device.model";
import {ImpulseService} from "./impulse.service";
import * as moment from 'moment';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from "@angular/material/core";
import {MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter} from "@angular/material-moment-adapter";
import {MY_FORMATS} from "../../shared/util.service";
import {DeviceInfoDialogComponent} from "../device-info-dialog/device-info-dialog.component";
import {DeviceInfo} from "../../model/device-info.model";
import {MatDialog} from "@angular/material/dialog";
import {CounterResetDialogComponent} from "./counter-reset-dialog/counter-reset-dialog.component";
@Component({
    selector: 'app-device-impulse',
    templateUrl: './device-impulse.component.html',
    styleUrls: ['./device-impulse.component.scss'],
    providers: [
        { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS] },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    ],
    standalone: false
})
export class DeviceImpulseComponent implements OnInit {
  @Input() device: Device;
  measureID = null;

  recordDateTime: any = {
    date: null,
    hour: null,
    time: null
  };
  minutes = [];
  hours = [];

  recording: any = {};
  counters: any[] = [];

  maxRecordDate = new Date();

  constructor(
    private service: ImpulseService,
    private dialog: MatDialog,
  ) { }

  ngOnInit() {
    if (!this.device || !this.device.id) {
      return false;
    }
    this.getMeasureID();
    this.initDates();
  }

  getMeasureID() {
    const measureID = this.device.getMeasureID();
    if (!measureID) {
      return this.service.notiService.open('Set Measure ID first in the Edit tab');
    }
    this.measureID = measureID;
    this.recording.measure = measureID;
    this.fetchCounters(measureID);

  }

  initDates() {
    for (let i = 0; i < 60; i++) {
      if (i < 10) {
        this.minutes.push(`0${i}`);
      } else {
        this.minutes.push(`${i}`)
      }
    }
    for (let i = 0; i < 24; i++) {
      if (i < 10) {
        this.hours.push(`0${i}`);
      } else {
        this.hours.push(`${i}`)
      }
    }
  }

  fetchCounters(measure) {
    this.service.fetchCounters(this.device.id, {measure}).subscribe(resp => {
      if (resp.error) {
        return this.service.notiService.open(resp.error)
      }
      if (resp.length) {
        this.counters = resp;
      }
    })
  }


  deleteRecording(data) {
    this.service.removeCounter(this.device.id, data).subscribe(resp => {
      if (resp && resp.deleted) {
        this.service.notiService.open('Counter deleted');

        const idx = this.counters.findIndex(el => el === data);
        if (idx > -1) {
          this.counters.splice(idx, 1);
        }
      }
    })
  }

  confirmDeleteRecording(data) {
    this.service.confirmAction().subscribe(confirm => {
      if (confirm) {
        this.deleteRecording(data)
      }
    })
  }

  saveRecording() {
    if (!this.recording.value) {
      return this.service.notiService.open('Set the recording value!');
    }

    if (!this.recordDateTime.date || !this.recordDateTime.hour || !this.recordDateTime.minute) {
      return this.service.notiService.open('Set the recording date, hour and minute!');
    }
    this.recording.time = `${this.recordDateTime.date.format('YYYY-MM-DD')} ${this.recordDateTime.hour}:${this.recordDateTime.minute}:00`;

    this.service.saveCounter(this.device.id, this.recording).subscribe(resp => {
      if (resp.error) {
        return this.service.notiService.open(resp.error);
      }
      this.service.notiService.open('Counter saved');
      this.counters.push(resp);
      this.counters.sort((a,b) => (a.time > b.time) ? -1 : ((b.time > a.time) ? 1 : 0))
      this.recording = {
        measure: this.measureID
      };
      this.recordDateTime = {
        date: null,
        hour: null,
        time: null
      }

    })
  }

  resetCounterFromDate() {
    const dialogRef = this.dialog.open(CounterResetDialogComponent, {
      data: {
        deviceID: this.device.id,
        measureID: this.measureID
      },
      minWidth: '300px',
      maxWidth: '500px'
    });

    dialogRef.afterClosed().subscribe( (result: any) => {
      if (result && result.node_id) {
        // reload conter table
        this.fetchCounters(this.measureID);
      }
    });
  }
}
